import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { Subject } from 'rxjs';

import { BaryComponentHelper } from '../../util/bary-component-helper';

import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-button',
  templateUrl: './bary-button.component.html',
  standalone: true,
  imports: [CommonModule, MDBBootstrapModulesPro, NgbModule, BaryIconComponent],
  styleUrls: ['./bary-button.component.scss'],
})
export class BaryButtonComponent implements OnInit {
  readonly #router = inject(Router);
  readonly #translateService = inject(TranslateService);

  @Input() disabled: boolean = false;
  @Input() isBtnBary: boolean = true;
  @Input() tooltip: string = '';
  @Input() class: string = 'btn bary-btn';
  @Input() color: 'primary' | 'secondary' | 'danger' | 'warning' | 'dark' | 'grey' | 'success' | 'main' | 'white' | 'link' | 'info' = 'primary';
  @Input() label?: string;
  @Input() outline: boolean = false;
  @Input() block: boolean = false;
  @Input() size: 'sm' | 'lg' | 'md' | '' = '';
  @Input() spinnerLabel?: string;
  @Input() id?: string;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() rounded: boolean = false;
  @Input() floating: boolean = false;
  @Input() icon?: string;
  @Input() goTo?: string[] | string;
  @Input() spinner?: Subject<any>;

  @Output() clickEvent = new EventEmitter<MouseEvent>();

  protected readonly FAS = FaDirectiveEnum.FAS;

  _class!: string;

  get _spinnerLabel(): string {
    return this.spinnerLabel || (this.#translateService.instant('LABEL.LOADING') as string);
  }

  public ngOnInit(): void {
    this._class = this.class + (this.isBtnBary ? ' bary-btn' : '') + (this.outline ? ' shadow-none' : '') + (this.floating ? ' border-0' : '');
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }
  }

  public handleClick(): void {
    if (!this.disabled && (!this.spinner || this.spinner?.isStopped)) {
      if (this.spinner) {
        this.spinner.isStopped = false;
        this.spinner.complete();
      }
      if (this.goTo) {
        if (this.goTo instanceof Array) {
          this.#router.navigate(this.goTo).then();
        } else {
          this.#router.navigateByUrl(this.goTo).then();
        }
      } else {
        this.clickEvent.emit();
      }
    }
  }
}
